export default class Param {
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
    get dto() {
        return Promise.resolve({
            Name: this.name,
            Value: this.value
        });
    }
}
//# sourceMappingURL=param.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/convertapi-js/dist/param.js
// module id = null
// module chunks = 